module.exports = __webpack_public_path__ + "img/logo.c642f42d.svg";